// Barra de acceso rápido: pocas funciones realmente frecuentes (Nota de Venta, Punto de Venta,
// Clientes, Stock, Cobrar…), configurables con la estrella de cada función en el menú. No es otra
// navegación completa: si hay más de unas pocas, se pide quitar alguna.
import { pantallaPorRuta, type Pantalla } from './navegacion';

const MAXIMO = 8;

export function BarraAccesos({
  favoritos,
  visible,
  alElegir,
}: {
  favoritos: string[];
  visible: (p: Pantalla) => boolean;
  alElegir: (p: Pantalla) => void;
}) {
  const lista = favoritos
    .map((r) => pantallaPorRuta(r))
    .filter((p): p is NonNullable<typeof p> => !!p && visible(p))
    .slice(0, MAXIMO);
  return (
    <div className="barra-accesos" role="group" aria-label="Accesos rápidos">
      {lista.map((p) => (
        <button
          key={p.ruta}
          type="button"
          className={p.accion ? 'operacion' : ''}
          data-ruta={p.ruta}
          title={`${p.modulo.nombre} › ${p.nombre}${p.tecla ? ` (${p.tecla})` : ''}`}
          onClick={() => alElegir(p)}
        >
          {p.nombre}
        </button>
      ))}
      {!lista.length && (
        <span className="apagado">Fija tus funciones frecuentes con ☆ en los menús.</span>
      )}
    </div>
  );
}
